<script setup lang="ts">
defineProps<{
  image?: string;
  quantity: number;
  title: string;
  variantTitle?: string;
}>();
</script>

<template>
  <li class="flex items-start gap-2 text-xs text-gray-500">
    <img
      v-if="image"
      :src="image"
      class="size-8 shrink-0 rounded border border-gray-200 object-contain shadow-sm"
      width="32"
      height="32"
      loading="lazy"
      alt=""
    />
    <div
      v-else
      class="size-8 shrink-0 rounded border border-gray-200 bg-gray-50"
    />

    <div class="flex flex-col gap-0.5 leading-tight">
      <span class="text-black-600">{{ quantity }} × {{ title }}</span>
      <span
        v-if="variantTitle && variantTitle !== 'Default Title'"
        class="text-gray-400"
      >
        {{ variantTitle }}
      </span>
    </div>
  </li>
</template>
